"use client";
import { createContext, useContext } from "react";
import { usePathname } from "next/navigation";
import { SupportedLanguages } from "@/types/dictionary";

const LangContext = createContext<string>(SupportedLanguages.EN);

export function LangProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname() || "";
  const lang = pathname.split("/")[1] || SupportedLanguages.EN;

  return <LangContext.Provider value={lang}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
